import React, { useEffect } from "react";
import { useState } from "react";
import { Col, Pagination, Row, Tab, Tabs } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Pagination2 from "../../Component/CutomPagination2";
import {
  DownloadGloabal,
  GetFunction,
  convertDate,
  handleimageUrl,
} from "../../utils/ApiFunctions";
import Question from "../../assets/img/question-mark.svg";
import moment from "moment/moment";
import View from "../../assets/img/eye.svg";
import Search from "../../assets/img/search-icon.svg";
import Grade from "../../assets/img/grade-1.svg";
import Star from "../../assets/img/student-profile.svg";
import Select from "react-select";
import Download from "../../assets/img/download.svg";
import Clock from "../../assets/img/clock.svg";
import Calendar from "../../assets/img/calendar-1.svg";
import { useLocalization } from "../../Component/Localization/Localization";
import Loader from "../../Component/Loader/Loader";
import PdfViewPopup from "../../Component/PdfViewImage";
import { GetValueLableWithId } from "../../utils/Helper";

function AwarnessList() {
  const { t, locale } = useLocalization();
  const [loader, setLoader] = useState(false);
  const { assessmentType } = useParams();
  const [keywords, setKeyWords] = useState("");
  const [schooList, setSchoolList] = useState([]);
  const [assignMentList, setAssignmentList] = useState([]);
  const [docmodal, setDocModal] = useState(false);
  const [docfile, setDocFile] = useState("");

  const [options, setOptions] = useState([]);
  const [options1, setOptions1] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [ueserids, setUserList] = useState([]);
  const [sectionId, setSctionId] = useState("");
  const usr = localStorage.getItem("user_id");
  const [type, setType] = useState("byme");
  const [filtertype, setFilterType] = useState("ongoing");
  const [page, setPage] = useState(1);
  const [getRoleList, setRoleList] = useState([]);
  const [selectedrole, setSelectRole] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [schoolId, setSchoolId] = useState(localStorage.getItem("school"));

  async function GetRoleList() {
    //     Trusty (By me)
    // Transport Admin (By me/To me)
    // Star Admin (By me/To me)
    // Staff and Assest Admin (By me/To me)

    // Driver
    // Supervisor
    // Parent
    // Guardian
    // Teacher
    // Nurse
    // Star
    // Shop
    const res = await GetFunction(`role/getAll?type=main&pages=all`);
    if (res.status == 200) {
      let roles = res?.data?.data;

      const rolesToExclude = [
        "star",
        "financeadmin",
        "security",
        "parent",
        "shop",
        "guardian",
        'transportadmin'

      ];

      roles = roles.filter((val) => !rolesToExclude.includes(val.name));

     
      setRoleList(
        roles?.sort((a, b) => {
          // Compare the 'name' property of each object
          const nameA = a.name.toLowerCase(); // Convert names to lowercase for case-insensitive sorting
          const nameB = b.name.toLowerCase();

          if (nameA < nameB) {
            return -1; // If nameA should come before nameB, return a negative value
          }

          if (nameA > nameB) {
            return 1; // If nameA should come after nameB, return a positive value
          }

          return 0; // If the names are equal, return 0
        })
      );
    }
  }

  async function GetSchoolList() {
    const res = await GetFunction(`school/get/list?user=${usr}&pages=all`);
    if (res.status == 200) {
      setSchoolList(res?.data?.data?.data);
    }
  }

  async function GetClassList() {
    const res = await GetFunction(
      `class/getAll?pages=all&schoolid=${schoolId}`
    );
    if (res.status == 200) {
      setSectionList(res?.data?.data?.data);
    }
  }

  async function GetList() {
    const res = await GetFunction(
      `assignments/get_assign_assignment_list?page=${page}&limit=${10}&keyword=${keywords}&assign=${type}&type=${filtertype}&assessmentType=${assessmentType}&role=${selectedrole}&classId=${sectionId}`
    );
    if (res.status == 200) {
      setLoader(false);
      setAssignmentList(res?.data?.data);
      setTotalPages(res?.data?.pagination?.totalPages);
    }
  }

  useEffect(() => {
    GetSchoolList();
    GetRoleList();
    GetClassList();
  }, []);
  useEffect(() => {
    setAssignmentList([]);
    setLoader(true);
    GetList();
  }, [
    filtertype,
    type,
    page,
    assessmentType,
    ueserids,
    keywords,
    selectedrole,
    sectionId,
  ]);

  const handlePageChange = (val) => {
    setPage(val);
  };

  // const GetUserList = async () => {
  //   const res = await GetFunction(
  //     `search/searchAllRole?roleName=${selectedrole}&school=${schoolId}&classId=${sectionId}`
  //   );
  //   if (res.status == 200) {
  //     setUserList(
  //       res?.data?.data
  //         ?.map((val, i) => {
  //           return val?._id;
  //         })
  //         .join(",")
  //     );
  //   }
  // };

  // useEffect(() => {
  //   if (selectedrole || sectionId) {
  //     GetUserList();
  //   }
  // }, [selectedrole, schoolId, sectionId]);

  // if (loader) {
  //   return <Loader />;
  // }]

  const optionsArray = [
    { value: "ongoing", label: "Ongoing", isSelected: true },
    { value: "submitted", label: "Submitted", isSelected: false },
    { value: "overdue", label: "Overdue", isSelected: false },
  ];

  useEffect(() => {
    setOptions(GetValueLableWithId(getRoleList, ["_id", "name"]));
  }, [getRoleList]);

  useEffect(() => {
    setOptions1(GetValueLableWithId(sectionList, ["_id", "name"]));
  }, [sectionList]);

  return (
    <div id="main" class="main-section-login">
      <section class="all-star-gallery">
        <div className="section-heading plage-steps-dtl my-4">
          <h2 className="justify-content-between">
            {" "}
            {assessmentType == "awarenessCourses"
              ? t("awareness_courses")
              : assessmentType == "worksheet"
              ? t("worksheet")
              : assessmentType == "lab"
              ? t("lab")
              : assessmentType == "assessment"
              ? t("assesment")
              : ""}
            <Link
              className="btn-btn-primary float-end"
              to={`/CreateAssignment/${assessmentType}`}
            >
              + {t("add")}{" "}
              {assessmentType == "awarenessCourses"
                ? t("awareness_courses")
                : assessmentType == "worksheet"
                ? t("worksheet")
                : assessmentType == "lab"
                ? t("lab")
                : assessmentType == "assessment"
                ? t("assesment")
                : ""}
            </Link>
          </h2>
        </div>
      </section>
      <section className="profile-aection bg-light new-class my-3 ">
        <Row className="p-3">
          <div
            className={
              locale == "ar"
                ? "filter-section-data filter-con-eng mt-2 "
                : "filter-from row cmn-frm  filter-conn mt-2"
            }
          >
            <Row>
              <Col md={3}>
                <div className="form-group">
                  {/* <select
                    onChange={(e) => {
                      setFilterType(e.target.value);
                      setPage(1);
                    }}
                    value={filtertype}
                  >
                    <option value="ongoing" selected>
                      Ongoing
                    </option>
                    <option value="submitted">Submitted</option>
                    <option value="overdue">Overdue</option>
                  </select> */}

                  <Select
                    options={optionsArray}
                    onChange={(option) => {
                      setFilterType(option.value);
                      setPage(1);
                    }}
                    value={optionsArray.find(
                      (option) => option.value === filtertype
                    )}
                  />
                </div>
              </Col>
              <Col md={3}>
                <div className="form-group">
                  {/* <select
                    onChange={(e) => setSelectRole(e.target.value)}
                    value={selectedrole}
                  >
                    <option selected value="">
                      {" "}
                      {t("select_role")}
                    </option>
                    {getRoleList &&
                      getRoleList?.map((val, i) => (
                        <option value={val?._id} key={i}>
                          {val?.displayName}
                        </option>
                      ))}
                  </select> */}

                  <Select
                    placeholder={t("select_role")}
                    options={options}
                    onChange={(option) => {
                      setSelectRole(option.value);
                    }}
                    value={options.find(
                      (option) => option.value === selectedrole
                    )}
                  />
                </div>
              </Col>
              <Col md={3}>
                {/* <select onChange={(e) => setSctionId(e.target.value)}>
                  <option selected value="">
                    {t("select_class")}
                  </option>
                  {sectionList &&
                    sectionList?.map((val, i) => (
                      <option value={val?._id}>{val?.name}</option>
                    ))}
                </select> */}

                <Select
                  placeholder={t("select_class")}
                  options={options1}
                  onChange={(option) => {
                    setSctionId(option.value);
                  }}
                  value={options1.find((option) => option.value === sectionId)}
                />
              </Col>
              <Col md={3}>
                <div className="form-group search-awarness">
                  <input
                    type="text"
                    placeholder={t("search_by_unique_id_or_user_name")}
                    value={keywords}
                    onChange={(e) => setKeyWords(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          </div>

          <Tabs
            defaultActiveKey="byme"
            // id="uncontrolled-tab-example"
            onSelect={(k) => {
              setFilterType("ongoing");
              setType(k);
              setPage(1);
            }}
            className="star-atendance mt-3 tabs-two flex-nowrap gap-2 inner-tabs"
          >
            <Tab
              eventKey="byme"
              title={t("assigned_by_me")}
              className="mt-3 tabs-thee flex-nowrap  gap-3"
            >
              {filtertype == "ongoing" && (
                <Row>
                  {loader && <Loader />}
                  {assignMentList?.length > 0
                    ? assignMentList?.map((val, i) => (
                        <Col md={6} key={i}>
                          <div class="my-info  px-0 shadow-none h-auto ">
                            <div>
                              <Link
                                to={`/questions/review/${assessmentType}/${val?.assignment}`}
                              >
                                <h2 className="mx-2">{val?.title}</h2>
                              </Link>
                            </div>
                            <ul className="dtl-brder">
                              {(assessmentType == "awarenessCourses" ||
                                assessmentType == "lab") && (
                                <li>
                                  <i>
                                    <img src={Question} />
                                  </i>
                                  {t("library_assignment_no")}:
                                  <span> {val?.assignmentNo}</span>
                                </li>
                              )}

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_type")}:
                                <span>
                                  {" "}
                                  {val?.type == "awarenessCourses"
                                    ? "Awarness & Courses"
                                    : val?.type}
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_to")}:
                                <span> {val?.assignTo?.name}</span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("submit_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.submitDate).format("DD/MM/YYYY")}
                                  <span className="float-end">
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                    {t("submit_time")}:
                                    {convertDate(val?.submitTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("assigned_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.postDate).format("DD/MM/YYYY")}
                                  <span className="float-end">
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                    {t("assigned_time")} :
                                    {convertDate(val?.postTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("due_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.dueDate).format("DD/MM/YYYY")}
                                </span>
                              </li>

                              {assessmentType == "lab" ||
                                (assessmentType == "worksheet" && (
                                  <li>
                                    <i>
                                      <img src={Question} />
                                    </i>
                                    {t("total_marks")}:
                                    <span> {val?.totalMarks}</span>
                                  </li>
                                ))}
                              {val?.supportDoc && (
                                <li>
                                  <span>{val?.supportDoc}</span>
                                  <i>
                                    <img
                                      src={View}
                                      onClick={() => {
                                        setDocModal(true);
                                        setDocFile(val?.supportDoc);
                                      }}
                                    />
                                  </i>
                                  <i>
                                    <img
                                      src={Download}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        DownloadGloabal(
                                          val?.supportDoc,
                                          val?.supportDoc
                                        );
                                      }}
                                    />
                                  </i>
                                </li>
                              )}
                              {val?.link && (
                                <li>
                                  <span>{val?.link}</span>
                                </li>
                              )}

                              {val?.description && (
                                <li>
                                  <span>{val?.description}</span>
                                </li>
                              )}
                            </ul>
                          </div>
                        </Col>
                      ))
                    : !loader && (
                        <div>
                          <center>
                            <h3>{t("no_data_found")}</h3>
                          </center>
                        </div>
                      )}
                </Row>
              )}

              {filtertype == "submitted" && (
                <Row>
                  {loader && <Loader />}
                  {assignMentList?.length > 0
                    ? assignMentList?.map((val, i) => (
                        <Col md={6} key={i}>
                          <div class="my-info my-nigg px-0 shadow-none h-auto">
                            <Link
                              to={`/questions/review/${assessmentType}/${val?.assignment}`}
                            >
                              <h2 className="mx-2">
                                {val?.title}

                                {
                                  <span className="float-right">
                                    {val?.submittedAt && t("test_submit_date")}:
                                    {moment(val?.submittedAt).format(
                                      "DD-MM-YYYY"
                                    )}{" "}
                                  </span>
                                }
                              </h2>
                            </Link>
                            <ul className="dtl-brder">
                              {(assessmentType == "awarenessCourses" ||
                                assessmentType == "lab") && (
                                <li>
                                  <i>
                                    <img src={Question} />
                                  </i>
                                  {t("library_assignment_no")}:
                                  <span> {val?.assignmentNo}</span>
                                </li>
                              )}
                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_type")}:{" "}
                                <span>
                                  {val?.type == "awarenessCourses"
                                    ? "Awarness & Courses"
                                    : val?.type}
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_to")}:
                                <span> {val?.assignTo?.name}</span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("submit_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.submitDate).format("DD/MM/YYYY")}
                                  <span className="float-end">
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                    {t("submit_time")}:
                                    {/* {new Date(val?.submitTime).toLocaleTimeString(
                                    [],
                                    {
                                      timeStyle: "short",
                                    }
                                  )} */}
                                    {convertDate(val?.submitTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("assigned_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.postDate).format("DD/MM/YYYY")}
                                  <span className="float-end">
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                    {t("assigned_time")} :
                                    {/* {new Date(val?.postTime).toLocaleTimeString(
                                    [],
                                    {
                                      timeStyle: "short",
                                    }
                                  )} */}
                                    {convertDate(val?.submitTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("due_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.dueDate).format("DD/MM/YYYY")}
                                </span>
                              </li>

                              {val?.supportDoc && (
                                <li>
                                  <span>{val?.supportDoc}</span>
                                  <i>
                                    <img
                                      src={View}
                                      onClick={() => {
                                        setDocModal(true);
                                        setDocFile(val?.supportDoc);
                                      }}
                                    />
                                  </i>
                                  <i>
                                    <img
                                      src={Download}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        DownloadGloabal(
                                          val?.supportDoc,
                                          val?.supportDoc
                                        );
                                      }}
                                    />
                                  </i>
                                </li>
                              )}
                              {val?.link && (
                                <li>
                                  <span>{val?.link}</span>
                                </li>
                              )}

                              {val?.description && (
                                <li>
                                  <span>{val?.description}</span>
                                </li>
                              )}
                            </ul>
                          </div>
                        </Col>
                      ))
                    : !loader && (
                        <div>
                          <center>
                            <h3>{t("no_data_found")}</h3>
                          </center>
                        </div>
                      )}
                </Row>
              )}

              {filtertype == "overdue" && (
                <Row>
                  {loader && <Loader />}
                  {assignMentList?.length > 0
                    ? assignMentList?.map((val, i) => (
                        <Col md={6} key={i}>
                          <div class="my-info px-0 shadow-none h-auto">
                            <Link
                              to={`/questions/review/${assessmentType}/${val?.assignment}`}
                            >
                              <h2 className="mx-2">{val?.title}</h2>
                            </Link>
                            <ul className="dtl-brder">
                              {(assessmentType == "awarenessCourses" ||
                                assessmentType == "lab") && (
                                <li>
                                  <i>
                                    <img src={Question} />
                                  </i>
                                  {t("library_assignment_no")}:
                                  <span> {val?.assignmentNo}</span>
                                </li>
                              )}
                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_type")}:
                                <span>
                                  {val?.type == "awarenessCourses"
                                    ? "Awarness & Courses"
                                    : val?.type}
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_to")}:
                                <span> {val?.assignTo?.name}</span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("submit_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.submitDate).format("DD/MM/YYYY")}
                                  <span className="float-end">
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                    {t("submit_time")}:
                                    {/* {new Date(val?.submitTime).toLocaleTimeString(
                                    [],
                                    {
                                      timeStyle: "short",
                                    }
                                  )} */}
                                    {convertDate(val?.submitTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("assigned_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.postDate).format("DD/MM/YYYY")}
                                  <span className="float-end">
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                    {t("assigned_time")} :
                                    {/* {new Date(val?.postTime).toLocaleTimeString(
                                    [],
                                    {
                                      timeStyle: "short",
                                    }
                                  )} */}
                                    {convertDate(val?.postTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("due_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.dueDate).format("DD/MM/YYYY")}
                                </span>
                              </li>

                              {val?.supportDoc && (
                                <li>
                                  <span>{val?.supportDoc}</span>
                                  <i>
                                    <img
                                      src={View}
                                      onClick={() => {
                                        setDocModal(true);
                                        setDocFile(val?.supportDoc);
                                      }}
                                    />
                                  </i>
                                  <i>
                                    <img
                                      src={Download}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        DownloadGloabal(
                                          val?.supportDoc,
                                          val?.supportDoc
                                        );
                                      }}
                                    />
                                  </i>
                                </li>
                              )}
                              {val?.link && (
                                <li>
                                  <span>{val?.link}</span>
                                </li>
                              )}

                              {val?.description && (
                                <li>
                                  <span>{val?.description}</span>
                                </li>
                              )}
                            </ul>
                          </div>
                        </Col>
                      ))
                    : !loader && (
                        <div>
                          <center>
                            <h3>{t("no_data_found")}</h3>
                          </center>
                        </div>
                      )}
                </Row>
              )}
            </Tab>

            <Tab eventKey="tome" title={t("assigned_to_me")} className="mt-3">
              {filtertype == "ongoing" && (
                <Row>
                  {loader && <Loader />}
                  {assignMentList?.length > 0
                    ? assignMentList?.map((val, i) => (
                        <Col md={6} key={i}>
                          <div class="my-info px-0 shadow-none h-auto">
                            <Link
                              to={`/questions/${val?.assignment}/${val?._id}`}
                            >
                              <h2 className="mx-2">{val?.title}</h2>
                            </Link>
                            <ul className="dtl-brder">
                              {(assessmentType == "awarenessCourses" ||
                                assessmentType == "lab") && (
                                <li>
                                  <i>
                                    <img src={Question} />
                                  </i>
                                  {t("library_assignment_no")}:
                                  <span> {val?.assignmentNo}</span>
                                </li>
                              )}
                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_type")}:
                                <span>
                                  {val?.type == "awarenessCourses"
                                    ? "Awarness & Courses"
                                    : val?.type}
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_to")}:
                                <span> {val?.assignTo?.name}</span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("submit_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.submitDate).format("DD/MM/YYYY")}
                                  <span className="float-end">
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                    {t("submit_time")}:
                                    {convertDate(val?.submitTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("assigned_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.postDate).format("DD/MM/YYYY")}
                                  <span className="float-end">
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                    {t("assigned_time")} :
                                    {/* {new Date(val?.postTime).toLocaleTimeString(
                                    [],
                                    {
                                      timeStyle: "short",
                                    }
                                  )} */}
                                    {convertDate(val?.postTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("due_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.dueDate).format("DD/MM/YYYY")}
                                </span>
                              </li>
                              {assessmentType == "lab" && (
                                <li>
                                  <i>
                                    <img src={Question} />
                                  </i>
                                  {t("total_marks")}:
                                  <span> {val?.totalMarks}</span>
                                </li>
                              )}
                              {/* tushar */}

                              {val?.supportDoc && (
                                <li>
                                  <span>{val?.supportDoc}</span>
                                  <i>
                                    <img
                                      src={View}
                                      onClick={() => {
                                        setDocModal(true);
                                        setDocFile(val?.supportDoc);
                                      }}
                                    />
                                  </i>
                                  <i>
                                    <img
                                      src={Download}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        DownloadGloabal(
                                          val?.supportDoc,
                                          val?.supportDoc
                                        );
                                      }}
                                    />
                                  </i>
                                </li>
                              )}
                              {val?.link && (
                                <li>
                                  <span>{val?.link}</span>
                                </li>
                              )}

                              {val?.description && (
                                <li>
                                  <span>{val?.description}</span>
                                </li>
                              )}
                            </ul>
                          </div>
                        </Col>
                      ))
                    : !loader && (
                        <div>
                          <center>
                            <h3>{t("no_data_found")}</h3>
                          </center>
                        </div>
                      )}
                </Row>
              )}

              {filtertype == "submitted" && (
                <Row>
                  {loader && <Loader />}
                  {assignMentList?.length > 0
                    ? assignMentList?.map((val, i) => (
                        <Col md={6} key={i}>
                          <div class="my-info px-0 my-nigg shadow-none h-auto">
                            <h2 className="mx-2">
                              {val?.title}
                              {
                                <span className="float-right">
                                  {val?.submittedAt && t("test_submit_date")}:
                                  {moment(val?.submittedAt).format(
                                    "DD-MM-YYYY"
                                  )}{" "}
                                </span>
                              }
                            </h2>

                            <ul className="dtl-brder">
                              {(assessmentType == "awarenessCourses" ||
                                assessmentType == "lab") && (
                                <li>
                                  <i>
                                    <img src={Question} />
                                  </i>
                                  {t("library_assignment_no")}:
                                  <span> {val?.assignmentNo}</span>
                                </li>
                              )}
                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_type")}:{" "}
                                <span>
                                  {val?.type == "awarenessCourses"
                                    ? "Awarness & Courses"
                                    : val?.type}
                                </span>
                                {val?.isReAttempt && (
                                  <span className="float-end mb-3">
                                    <Link
                                      className="btn-btn-oranges p-1"
                                      to={`/questions/${val?.assignment}/${val?._id}`}
                                    >
                                      {t("reAttempt")}
                                    </Link>
                                  </span>
                                )}
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_to")}:
                                <span> {val?.assignTo?.name}</span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("submit_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.submitDate).format("DD/MM/YYYY")}
                                  <span>
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                  </span>
                                  <span className="float-end">
                                    {t("submit_time")}:
                                    {convertDate(val?.submitTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("assigned_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.postDate).format("DD/MM/YYYY")}
                                  <span className="float-end">
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                    {t("assigned_time")} :
                                    {/* {new Date(val?.postTime).toLocaleTimeString(
                                    [],
                                    {
                                      timeStyle: "short",
                                    }
                                  )} */}
                                    {convertDate(val?.postTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("due_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.dueDate).format("DD/MM/YYYY")}
                                </span>
                              </li>

                              {val?.supportDoc && (
                                <li>
                                  <span>{val?.supportDoc}</span>
                                  <i>
                                    <img
                                      src={View}
                                      onClick={() => {
                                        setDocModal(true);
                                        setDocFile(val?.supportDoc);
                                      }}
                                    />
                                  </i>
                                  <i>
                                    <img
                                      src={Download}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        DownloadGloabal(
                                          val?.supportDoc,
                                          val?.supportDoc
                                        );
                                      }}
                                    />
                                  </i>
                                </li>
                              )}
                              {val?.link && (
                                <li>
                                  <span>{val?.link}</span>
                                </li>
                              )}

                              {val?.description && (
                                <li>
                                  <span>{val?.description}</span>
                                </li>
                              )}
                            </ul>
                          </div>
                        </Col>
                      ))
                    : !loader && (
                        <div>
                          <center>
                            <h3>{t("no_data_found")}</h3>
                          </center>
                        </div>
                      )}
                </Row>
              )}

              {filtertype == "overdue" && (
                <Row>
                  {loader && <Loader />}
                  {assignMentList?.length > 0
                    ? assignMentList?.map((val, i) => (
                        <Col md={6} key={i}>
                          <div class="my-info px-0 shadow-none h-auto">
                            <h2 className="mx-2">{val?.title}</h2>
                            <ul className="dtl-brder">
                              {(assessmentType == "awarenessCourses" ||
                                assessmentType == "lab") && (
                                <li>
                                  <i>
                                    <img src={Question} />
                                  </i>
                                  {t("library_assignment_no")}:
                                  <span> {val?.assignmentNo}</span>
                                </li>
                              )}
                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_type")}:{" "}
                                <span>
                                  {val?.type == "awarenessCourses"
                                    ? "Awarness & Courses"
                                    : val?.type}
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("assignment_to")}:
                                <span> {val?.assignTo?.name}</span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("submit_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.submitDate).format("DD/MM/YYYY")}
                                  <span className="float-end">
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                    {t("submit_time")}:
                                    {/* {new Date(val?.submitTime).toLocaleTimeString(
                                    [],
                                    {
                                      timeStyle: "short",
                                    }
                                  )} */}
                                    {convertDate(val?.submitTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Calendar} />
                                </i>
                                {t("assigned_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.postDate).format("DD/MM/YYYY")}
                                  <span className="float-end">
                                    <i>
                                      <img src={Clock} />
                                    </i>{" "}
                                    {t("assigned_time")} :
                                    {/* {new Date(val?.postTime).toLocaleTimeString(
                                    [],
                                    {
                                      timeStyle: "short",
                                    }
                                  )} */}
                                    {convertDate(val?.postTime)}
                                  </span>
                                </span>
                              </li>

                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("due_date")}:
                                <span>
                                  {" "}
                                  {moment(val?.dueDate).format("DD/MM/YYYY")}
                                </span>
                              </li>

                              {assessmentType == "lab" && (
                                <li>
                                  <i>
                                    <img src={Question} />
                                  </i>
                                  {t("total_marks")}:
                                  <span> {val?.totalMarks}</span>
                                </li>
                              )}
                              {val?.supportDoc && (
                                <>
                                  <i>
                                    <img
                                      src={View}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setDocModal(true);
                                        setDocFile(val?.supportDoc);
                                      }}
                                    />
                                  </i>
                                  <i>
                                    <img
                                      src={Download}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        DownloadGloabal(
                                          val?.supportDoc,
                                          val?.supportDoc
                                        );
                                      }}
                                    />
                                  </i>
                                </>
                              )}
                              {assessmentType == "awarenessCourses" ||
                                (assessmentType == "lab" && (
                                  <li>
                                    <span>{val?.link}</span>
                                  </li>
                                ))}

                              {assessmentType == "worksheet" && (
                                <li>
                                  <span>{val?.description}</span>
                                </li>
                              )}
                            </ul>
                          </div>
                        </Col>
                      ))
                    : !loader && (
                        <div>
                          <center>
                            <h3>{t("no_data_found")}</h3>
                          </center>
                        </div>
                      )}
                </Row>
              )}
            </Tab>
          </Tabs>
          <Pagination2
            total={totalPages}
            current={page}
            pagination={handlePageChange}
          />
          {/* <Pagination>{renderPageNumbers()}</Pagination> */}
        </Row>
      </section>
      <PdfViewPopup
        show={docmodal}
        onHide={() => setDocModal(false)}
        image={docfile}
      />
    </div>
  );
}

export default AwarnessList;
